/**
 * 工具函数 — 仿照 shadcn/ui 的 cn（clsx + tailwind-merge）
 * 用于动态拼接 className，解决 Tailwind 类名冲突问题。
 */
import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
